import { render, staticRenderFns } from "./DropOffDeviceIndex.vue?vue&type=template&id=3124613d&scoped=true&"
import script from "./DropOffDeviceIndex.vue?vue&type=script&lang=js&"
export * from "./DropOffDeviceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124613d",
  null
  
)

export default component.exports